import { format_ShortDOW_Date, getShiftTime } from "./dateTimeFormatter";

export const parseOfferedReliefShift = (trade) => {
  return trade.isOfferedReliefShift ? "YES" : "NO";
};
export const parseRequestedReliefShift = (trade) => {
  return trade.isRequestedReliefShift === undefined ? "" : trade.isRequestedReliefShift ? "YES" : "NO";
};
export const parseTradeBetweenAgentAndSup = (trade) => {
  return trade.isSupervisorInvolved ? "YES" : "NO";
};
export const parseOfferedEmployeeName = (trade) => {
  return `${trade.offeredEmployeeLastName}, ${trade.offeredEmployeeFirstName}`;
};
export const parseRequestedEmployeeName = (trade) => {
  return `${trade.requestedEmployeeLastName}, ${trade.requestedEmployeeFirstName}`;
};

export const parseRequestedShift = (trade) => {
  if (trade.requestedShiftStart) {
    return (
      format_ShortDOW_Date(trade.requestedShiftStart) +
      " " +
      getShiftTime(trade.requestedShiftStart) +
      "-" +
      getShiftTime(trade.requestedShiftEnd)
    );
  } else {
    return "";
  }
};
export const parseOfferedShift = (trade) => {
  return (
    format_ShortDOW_Date(trade.offeredShiftStart) +
    " " +
    getShiftTime(trade.offeredShiftStart) +
    "-" +
    getShiftTime(trade.offeredShiftEnd)
  );
};

export const parseStatusValue = (trade) => {
  return trade["visibleTradeStatusAdmin"];
};
export const parseShiftWorkgroup = (trade) => {
  return trade.workgroup;
};

export const parseOfferedEmployeeId = (trade) => {
  return trade.offeredEmployeeId;
};

export const parseRequestedEmployeeId = (trade) => {
  return trade.requestedEmployeeId;
};

export const parseOfferedWorkgroup = (trade) => {
  return trade.offeredEmployeeWorkgroup;
};

export const parseRequestedWorkgroup = (trade) => {
  return trade.requestedEmployeeWorkgroup;
};


